/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
import Rails from "@rails/ujs"
Rails.start()
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
window.Rails = Rails;
require('jquery')
window.jQuery = $;
window.$ = $;
// require("bootstrap")

const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

// import "bootstrap"
import Swiper from "swiper";
require('./help/jquery-ui')
require('./help/jquery.easy-autocomplete')

//  Must require bootstrap-sprockets after jquery
//= require bootstrap-sprockets
//= require bootstrap-datepicker/core
require('./bootstrap-select')
require('../vendor/assets/bootstrap-switch/bootstrap-switch.min')
require('../vendor/assets/bootstrap-timepicker/bootstrap-timepicker.min')
// require('../vendor/assets/javascripts/pdf')
// require('../vendor/assets/javascripts/pdf.worker')
// require('../vendor/assets/javascripts/viewer')
require('./tooltipster.bundle.min')

// require('filterrific/filterrific-jquery')
require('select2')
//= require tinymce
//= require select2-full

// require('../vendor/assets/javascripts/pdf')
// require('../vendor/assets/javascripts/pdf.worker')
// require('../vendor/assets/javascripts/viewer')
// require('../vendor/assets/javascripts/swiper-bundle.min.js')
require('swiper')
//= require cocoon

require('./application_code.js')
require('./relationship_policies')
require('./users')
require('./courses')
require('./feature_message')
require('./experience')
require('./instant_booking')
require('./block_ui.min')
require('./jquery_validation.min.js')

import "../stylesheets/application"
$.fn.selectpicker.Constructor.BootstrapVersion = '3.3.7';
